export default {
    methods: {
        onContextMenu(e) {
            // 0. Prepare
            // 0.1 check first
            if(!this.gridInfo.opts.context && !this.field.context) return; // no context
            // 0.2 Prevent default
            // TODO Check : on Context? same cell? -> default context & don't refresh context.
            e.preventDefault();
            // 1. Calc pos
            var pos = this.__getPos(e);
            // 2. Make context menu
            var ctxs = this.__getCtxs();
            if( !ctxs.length ) return; // no context too.
            // x. return
            const v = this.value, r = this.rowInfo.row;
            this.gridInfo.func.openContext(v,r,ctxs,pos);
        },
        // [METHODS][LOCAL] Get context position.
        __getPos(e) {
            // 0. Prepare
            var pos = {}
            // 1. Get DOM location
            const $tab = this.gridInfo.refs.table,
                tbRect = $tab.getBoundingClientRect();
            const mx = e.clientX, my = e.clientY;
            var scrWidth  = document.body.clientWidth;
            var scrHeight = document.body.clientHeight;
            // 2. check position
            var px = mx - tbRect.left; if(px < 0) px = 0;
            var py = my - tbRect.top;  if(py < 0) py = 0;
            // 3. Check direction
            pos[scrWidth >mx*2 ? 'left' : 'right'] = px
            pos[scrHeight>my*2 ? 'top' : 'bottom'] = py
            // x. Return result
            return pos;
        },
        // [METHODS][LOCAL] Get context contents.
        __getCtxs() {
            // 0. Prepare
            const v = this.value,
                  r = this.rowInfo.row,
                  f = this.field;
            var ctxs = [], res,
                gCtx = this.gridInfo.opts.context,
                fCtx = f.context;
            // 1. set Global contexts
            if(gCtx) {
                res = null;
                // 1.1 Build global context
                if(typeof gCtx === 'function') {
                    res = gCtx(v,r);
                } else if(Array.isArray(gCtx)) {
                    res = gCtx;
                } else {
                    console.warn('[UIDev] Unexpected context setting. Please check context setting on grid options.')
                }
                // 1.2 Add option contexts
                if(Array.isArray(res)) {
                    ctxs.push(...res);
                } else if(!!res && typeof res === 'object') {
                    ctxs.push(res);
                }
            }
            // 2. set Field contexts
            if(fCtx) {
                res = null;
                // 2.1 Build field-context
                if(typeof fCtx === 'function') {
                    res = fCtx(v,r);
                } else if(Array.isArray(fCtx)) {
                    res = fCtx;
                } else {
                    console.warn('[UIDev] Unexpected context setting. Please check the field definition on ['+f.value+'].')
                }
                // 2.2 Do I need separator on context?
                //     ≒ .g-ctx + .f-ctx {border-top}
                if(ctxs.length && res && res.length) {
                    ctxs.push({separator:true});
                }
                // 2.3 Add field contexts
                if(Array.isArray(res)) {
                    ctxs.push(...res);
                } else if(!!res && typeof res === 'object') {
                    ctxs.push(res);
                }
            }
            // x. Return result
            return ctxs
        }
    }
}